import type {
  FetchLegacyTopicBriefingFailureAction,
  FetchLegacyTopicBriefingSuccessAction,
  FetchTopicPresentationAction,
  FetchTopicPresentationFulfilledAction,
  FetchTopicPresentationRejectedAction,
} from "domains/topic/actionTypes";
import { LegacyTopicActionTypes } from "domains/topic/actionTypes";

export const fetchLegacyTopicBriefingSuccess = (): FetchLegacyTopicBriefingSuccessAction => ({
  type: LegacyTopicActionTypes.FETCH_BRIEFING_SUCCESS,
});

export const fetchLegacyTopicBriefingFailure = (
  meta: FetchLegacyTopicBriefingFailureAction["meta"],
): FetchLegacyTopicBriefingFailureAction => ({
  type: LegacyTopicActionTypes.FETCH_BRIEFING_FAILURE,
  meta,
});

export const fetchTopicPresentation = (
  payload: FetchTopicPresentationAction["payload"],
): FetchTopicPresentationAction => ({
  type: LegacyTopicActionTypes.FETCH_PRESENTATION,
  payload,
});

export const fetchTopicPresentationFulfilled = (): FetchTopicPresentationFulfilledAction => ({
  type: LegacyTopicActionTypes.FETCH_PRESENTATION_FULFILLED,
});

export const fetchTopicPresentationRejected = (
  meta: FetchTopicPresentationRejectedAction["meta"],
): FetchTopicPresentationRejectedAction => ({ meta, type: LegacyTopicActionTypes.FETCH_PRESENTATION_REJECTED });
